import { __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
import { buttonVariants } from './variants';
const InternalButton = (props, ref) => {
    const { as, children, iconBefore, iconAfter, className, labelClassName, variant = 'default', link, disabled, active, ghost, text, quite, block, size, dry, outlined } = props, rest = __rest(props, ["as", "children", "iconBefore", "iconAfter", "className", "labelClassName", "variant", "link", "disabled", "active", "ghost", "text", "quite", "block", "size", "dry", "outlined"]);
    const strategy = getBtnStrategy({
        link,
        ghost,
        text,
        quite,
        outlined,
    });
    const classes = clsx('btn', buttonVariants({
        variant,
        size,
        strategy,
    }), className, {
        'btn-icon': !children,
        'btn-block': block,
        'btn-dry': dry,
        disabled,
        active,
    });
    const Component = as || 'button';
    const type = rest.type || (Component === 'button' ? 'button' : undefined);
    const role = rest.role || (Component !== 'button' ? 'button' : undefined);
    return (React.createElement(Component, Object.assign({ role: role }, rest, { type: type, ref: ref, disabled: disabled, "aria-disabled": disabled, className: classes }),
        iconBefore,
        !!children && (React.createElement("span", { className: clsx('btn-label', labelClassName) }, children)),
        iconAfter));
};
function getBtnStrategy({ link, ghost, text, quite, outlined, }) {
    switch (true) {
        case link:
            return 'link';
        case quite:
            return 'quite';
        case ghost:
            return 'ghost';
        case text:
            return 'text';
        case outlined:
            return 'outlined';
        default:
            return 'default';
    }
}
export const Button = React.forwardRef(InternalButton);
//# sourceMappingURL=Button.js.map